import "./css/styles.css";
import "antd/dist/antd.css";
import "@formily/antd/dist/antd.css";
import "@designable/react/dist/designable.react.umd.production.min.css";
import "@designable/react-settings-form/dist/designable.settings-form.umd.production.min.css";
import { useState } from "react";
import FormDesigner from "./FormDesigner";
import LoginPage from "./LoginPage";
import { isAuthenticated, logout } from "./api";

function App() {
  const [authed, setAuthed] = useState(isAuthenticated());

  if (!authed) {
    return <LoginPage onSuccess={() => setAuthed(true)} />;
  }

  const handleSignOut = () => {
    logout();
    setAuthed(false);
  };

  return <FormDesigner onSignOut={handleSignOut} />;
}

export default App;
